import React, { useEffect, useState } from 'react'
import AdminConsoleHeader from '../AdminConsoleHeader'
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';
import AdminAccountFilterSelection from '../AdminAccountFilterSelection';
import BOMManagementList from './BOMManagementList';
import { useAdminBOMStore } from 'src/hooks/admin/adminBom';
import alertic from 'src/assets/images/yellow-alert.png';

const BOMManagement = () => {
    const [searchData, setSearchData] = useState('');
    const [error, setError] = useState('');
    const [{ filter_list }, { }, { set_filter_list }] = useAdminAccountFilterStore();
    const [{ }, { get_bom_list }, { set_bom_list, set_message }] = useAdminBOMStore();
    const onSearch = async (e) => {
        e.preventDefault();
        let filterObject = {}
        if (searchData?.trim().length == 0) {
            setError("Please enter the complete BOM ID.")
            return;
        }
        setError('');
        filterObject['BomID'] = {
            searchType: 'BOM ID',
            searchKeyword: searchData
        }
        set_filter_list(filterObject)
        // fetchBomList(searchData)
    }
    const fetchBomList = async (data) => {
        await get_bom_list(data)
    }
    useEffect(() => {
        if (filter_list?.BomID?.searchKeyword) {
            setSearchData(filter_list.BomID.searchKeyword)
            fetchBomList(filter_list.BomID.searchKeyword)
        } else {
            setSearchData('')
            set_message('')
            set_bom_list([])
        }
    }, [filter_list])

    return (
        <div className='adminconsole-container'>
            <AdminConsoleHeader title='BOM MANAGEMENT' />
            <div className='container mt-3 mb-3'>
            {error?.trim()?.length > 0 ?
                <div className="alert alert-danger fade in font-16 mb-2">
                    <span>{error}</span>
                    <img className="ms-auto" src={alertic} />
                </div> : ''
            }
            </div>
            <div className='accountdetails mt-2 bom-management'>
                <div className='acsearchuser'>
                    <div className='bg-grey2'>
                        <div className='container pt-3'>
                            <div className="accordion-item ">
                                <h2 className="accordion-header" id="searchInput">
                                    <button className="accordion-button" type="button" data-toggle="collapse"
                                        data-target="#collapseSearch" aria-expanded="true" aria-controls="collapseOne">
                                        <b className="font-16">Search</b>
                                    </button>
                                </h2>

                                <div id="collapseSearch" className="accordion-collapse collapse in" aria-labelledby="searchInput"
                                    data-parent="#accordionExample">
                                    <div className="accordion-body p-0">

                                        <form onSubmit={(e) => { onSearch(e) }} >
                                            <div className="row bs5 m-t-30 ms-0 me-0 ">
                                                <div className="col-sm-12 col-md-5 mb-2 usersearch-container">
                                                    <label htmlFor="bomId">BOM ID* </label>
                                                    <input className="ps-2 form-control form-control-sm mb-0" placeholder="BOM ID" type="text"
                                                        value={searchData}
                                                        onChange={({ target: { value } }) => setSearchData(value)}
                                                    />
                                                </div>
                                                <div className='co-md-12'></div>
                                                <div className="col-sm-12 col-md-5 text-sm-end pe-0 mt-2 pb-3">
                                                    <button className="btn btn-secondary bs5 minw140"
                                                    >Search
                                                    </button>
                                                </div>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AdminAccountFilterSelection />
                    <div>
                        <BOMManagementList />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BOMManagement
